export { default } from './themed-logo';
